import { render, staticRenderFns } from "./FooterText.vue?vue&type=template&id=79587caa&scoped=true&"
import script from "./FooterText.vue?vue&type=script&lang=js&"
export * from "./FooterText.vue?vue&type=script&lang=js&"
import style0 from "./FooterText.vue?vue&type=style&index=0&id=79587caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79587caa",
  null
  
)

export default component.exports